module.exports = __webpack_public_path__ + "static/images/p-error.ab8fb87.png";